import {Injectable} from '@angular/core';
import {Receipt, ReceiptItem, ReceiptItemProductCandidate} from "../../models/receipt";
import {Observable} from "rxjs";
import {environment} from '../../env';
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class ReceiptService {

  constructor(private http: HttpClient) {
  }

  receipts(householdId: number): Observable<Receipt[]> {
    return this.http.get<Receipt[]>(`${environment.apiUrl}/households/${householdId}/receipts`);
  }

  receipt(receiptId: number): Observable<Receipt> {
    return this.http.get<Receipt>(`${environment.apiUrl}/receipts/${receiptId}`);
  }

  receiptItems(receiptId: number): Observable<ReceiptItem[]> {
    return this.http.get<any>(`${environment.apiUrl}/receipts/${receiptId}/items?sort=is_imported,asc`);
  }

  receiptItem(receiptId: number, receiptItemId: number): Observable<ReceiptItem> {
    return this.http.get<ReceiptItem>(`${environment.apiUrl}/receipts/${receiptId}/items/${receiptItemId}`);
  }

  selectProductCandidate(receiptId: number, receiptItemId: number, candidateId: number): Observable<any> {

    const body = {
      selected_product_candidate_id: candidateId
    }

    return this.http.patch<any>(`${environment.apiUrl}/receipts/${receiptId}/items/${receiptItemId}`, body);
  }

  createProductCandidate(receiptId: number, receiptItemId: number, productCandidate: ReceiptItemProductCandidate): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/receipts/${receiptId}/items/${receiptItemId}/product-candidates`, productCandidate);
  }

  selectTargetStoreId(receiptId: number, receiptItemId: number, storeId: number): Observable<any> {

    const body = {
      target_store_id: storeId
    }

    return this.http.patch<any>(`${environment.apiUrl}/receipts/${receiptId}/items/${receiptItemId}`, body);
  }

  uploadReceipt(householdId: number, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('receipt', file);

    return this.http.post<any>(`${environment.apiUrl}/households/${householdId}/receipts/import`, formData);
  }

  importReceiptToStock(receiptId: number): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/receipts/${receiptId}/import-to-stock`, {});
  }

  deleteReceipt(receiptId: number): Observable<any> {
    return this.http.delete<any>(`${environment.apiUrl}/receipts/${receiptId}`);
  }

}
